module.exports = "<>\n  <Form.Label>Range</Form.Label>\n  <Form.Range />\n</>;\n"